import "lenis/dist/lenis.css";
import { useLenis } from "@/lib/lenis";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Channels } from "@/components/site/Channels";
import { About } from "@/components/site/About";
import { MediaKit } from "@/components/site/MediaKit";
import { Highlights } from "@/components/site/Highlights";
import { Partnership } from "@/components/site/Partnership";
import { Contact, Footer } from "@/components/site/Contact";

function App() {
  useLenis();
  return (
    <main className="overflow-x-clip">
      <Nav />
      <Hero />
      <Marquee />
      <Channels />
      <About />
      <MediaKit />
      <Highlights />
      <Partnership />
      <Contact />
      <Footer />
    </main>
  );
}

export default App;
